import React, { useState } from "react";
import { FLAGS } from "../../helpers/flags";
import "./Navigation.css";

const TRANSLATIONS = {
  tr: {
    home: "ANA SAYFA",
    services: "HİZMETLER",
    articles: "DUYURULAR",
    contact: "İLETİŞİM",
    quickAppointment: "Hızlı Randevu Al",
  },
  en: {
    home: "HOME",
    services: "SERVICES",
    articles: "ANNOUNCEMENTS",
    contact: "CONTACT",
    quickAppointment: "QUICK APPOINTMENT",
  },
  fr: {
    home: "ACCUEIL",
    services: "SERVICES",
    articles: "ANNONCES",
    contact: "CONTACT",
    quickAppointment: "Rendez-vous Rapide",
  },
};

const MENU_ITEMS = [
  { key: "home", path: "/" },
  { key: "services", path: "/services" },
  { key: "articles", path: "/articles" },
  { key: "contact", path: "/contact" },
];

const LANGUAGES = ["TR", "EN", "FR"];

function Navigation({ lang = "TR", setLang, isDarkMode, toggleTheme, onQuickAppointment, onNavigate }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const currentLang = lang.toLowerCase();
  const t = TRANSLATIONS[currentLang] || TRANSLATIONS.tr;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (e, key, path) => {
    e.preventDefault();
    closeMobileMenu();
    if (onNavigate) {
      onNavigate(key, path);
    }
  };

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top main-navigation ${isDarkMode ? "theme-dark" : "navbar-light"}`}
    >
      <div className="container nav-container">
        {/* Logo */}
        <a
          className="navbar-brand-custom"
          href="/"
          onClick={(e) => handleNavClick(e, "home", "/")}
        >
          <img
            src={isDarkMode ? "/img/logo-dark.png" : "/img/logo-light.png"}
            alt="Akay Conseil Logo"
            className="nav-logo-img"
          />
        </a>

        {/* Language Switcher */}
        <div className="language-switcher">
          {LANGUAGES.map((code) => (
            <button
              key={code}
              type="button"
              className={`nav-flag-btn ${lang === code ? "active" : ""}`}
              onClick={() => setLang(code)}
              aria-label={`Switch to ${code}`}
            >
              {FLAGS[code]}
            </button>
          ))}
        </div>

        {/* Dark Mode Toggle */}
        <button
          type="button"
          className="theme-toggle-btn"
          onClick={toggleTheme}
          aria-label="Toggle theme"
        >
          <i className={`fa ${isDarkMode ? "fa-moon-o" : "fa-sun-o"}`}></i>
        </button>

        {/* Hamburger Menu */}
        <button
          className={`navbar-toggler custom-toggler ${isDarkMode ? "dark-mode" : ""} ${isMobileMenuOpen ? "open" : ""}`}
          type="button"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation"
        >
          <span className="toggler-line"></span>
          <span className="toggler-line"></span>
          <span className="toggler-line"></span>
        </button>

        {/* Desktop Menu */}
        <div className={`collapse navbar-collapse ${isMobileMenuOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav mx-auto align-items-center">
            {MENU_ITEMS.map((item) => (
              <li className="nav-item" key={item.key}>
                <a
                  href={item.path}
                  className="nav-link nav-custom-link"
                  onClick={(e) => handleNavClick(e, item.key, item.path)}
                >
                  {t[item.key]}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Appointment Button */}
        <button
          type="button"
          className="btn-nav-action desktop-btn"
          onClick={() => {
            onQuickAppointment();
            closeMobileMenu();
          }}
        >
          {t.quickAppointment}
        </button>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isDarkMode ? "dark" : ""} ${isMobileMenuOpen ? "open" : ""}`}>
          <ul className="mobile-nav-list">
            {MENU_ITEMS.map((item) => (
              <li className="mobile-nav-item" key={item.key}>
                <a
                  href={item.path}
                  className="mobile-nav-link"
                  onClick={(e) => handleNavClick(e, item.key, item.path)}
                >
                  {t[item.key]}
                </a>
              </li>
            ))}
            <li className="mobile-nav-item">
              <button
                type="button"
                className="btn-nav-action mobile-btn"
                onClick={() => {
                  onQuickAppointment();
                  closeMobileMenu();
                }}
              >
                {t.quickAppointment}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;